module.exports = __webpack_public_path__ + "img/icon_flag_fr.2f98bac2.svg";